module.exports = __webpack_public_path__ + "assets/img/EmptyList@2x.f84a0ddf.png";